import styled, { css } from 'styled-components';
import { Row } from '@simplywallst/ui-core';

export const ControlContainer = styled.div`
  display: block;
  animation: fadein 0.35s ease-in;
  padding: 6rem 4rem;
  background-color: ${({ theme }) => theme.color.darkerGrayRGBA(0.05)};
`;

interface CollapsibleRowsProps {
  hideBorder?: boolean;
}

export const CollapsibleRows = styled(Row)<CollapsibleRowsProps>`
  ${({ theme, hideBorder }) => css`
    box-sizing: border-box;
    border-bottom: 1px solid ${theme.color.darkerGrayRGBA(0.2)};
    ${hideBorder
      ? css`
          border: none;
        `
      : ``}
    .rc-slider {
      .rc-slider-mark {
        top: -42px;
        .rc-slider-mark-text {
          ${theme.typography.xSmall}
        }
      }
      .rc-slider-handle {
        width: 32px;
        height: 32px;
        background: ${theme.color.brand01RGBA(0.5)};
        border: 2px solid ${theme.color.brand01RGBA(0.2)};
        box-sizing: border-box;
        border-radius: 16px;
        transform: translate(-28%, -30%);
        margin-top: -14px;
        &::after {
          content: ' ';
          display: block;
          position: absolute;
          width: 8px;
          height: 8px;
          border-radius: 4px;
          background-color: ${theme.color.brand01};
          left: 50%;
          top: 50%;
          margin-top: -4px;
          margin-left: -4px;
        }
      }
    }
  `}
`;
